import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.925 4.083 3.229 11.48c-.305.233-.305.81 0 1.042l9.695 7.396c.308.234.694-.056.694-.521V4.604c0-.465-.386-.756-.694-.52Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20.306 4.083-9.695 7.396c-.306.233-.306.81 0 1.042l9.695 7.396c.308.234.694-.056.694-.521V4.604c0-.465-.386-.756-.694-.52Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=RewindIcon24.js.map